'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { hexToRgb, rgbToHex, rgbToHsv } from './colorUtils';
const Container = styled(Box)(({ theme }) => ({
    width: '100%',
    height: 'auto',
    flexShrink: 0,
    display: 'flex',
    gap: '8px',
    marginTop: '16px',
    [theme.breakpoints.down('md')]: {
        // width: '100%',
        maxWidth: '100%',
        flexWrap: 'wrap',
        gap: '6px'
    },
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: 'auto',
        flexDirection: 'column',
        gap: '8px',
        marginTop: '12px'
    }
}));
const HexField = styled(TextField)(({ theme }) => ({
    width: '104px',
    '& .MuiInputBase-root': {
        height: '40px',
        fontSize: '14px',
        fontFamily: '"Open Sans"'
    },
    '& .MuiInputLabel-root': {
        fontSize: '14px',
        fontWeight: 600,
        fontFamily: '"Open Sans"'
    },
    [theme.breakpoints.down('md')]: {
        width: '100%',
        maxWidth: '104px'
    },
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '36px'
    }
}));
const RgbField = styled(TextField)(({ theme }) => ({
    width: '78px',
    '& .MuiInputBase-root': {
        height: '40px',
        fontSize: '14px',
        fontFamily: '"Open Sans"'
    },
    '& .MuiInputLabel-root': {
        fontSize: '14px',
        fontWeight: 600,
        fontFamily: '"Open Sans"'
    },
    [theme.breakpoints.down('md')]: {
        width: 'calc(33% - 4px)',
        maxWidth: '78px'
    },
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '36px'
    }
}));
const ColorValuesComp = ({ values, onChange }) => {
    const [hexInput, setHexInput] = React.useState(values.hex.toUpperCase());
    // Keep local hexInput in sync with values.hex from parent
    React.useEffect(() => {
        if (values.hex.toUpperCase() !== hexInput) {
            setHexInput(values.hex.toUpperCase());
        }
    }, [values.hex]);
    const handleHexChange = (event) => {
        const hex = event.target.value;
        setHexInput(hex);
        if (/^#[0-9A-Fa-f]{6}$/.test(hex)) {
            const rgb = hexToRgb(hex);
            const hsv = rgbToHsv(rgb.r, rgb.g, rgb.b);
            onChange?.({
                hex, // preserve case as entered
                rgb,
                hsv
            });
        }
    };
    const handleRgbChange = (component) => (event) => {
        const value = Number.parseInt(event.target.value);
        if (value >= 0 && value <= 255) {
            const newRgb = { ...values.rgb, [component]: value };
            const hex = rgbToHex(newRgb.r, newRgb.g, newRgb.b);
            const hsv = rgbToHsv(newRgb.r, newRgb.g, newRgb.b);
            onChange?.({
                hex: hex.toUpperCase(),
                rgb: newRgb,
                hsv
            });
        }
    };
    return (_jsxs(Container, { children: [_jsx(HexField, { label: "Hex", value: hexInput, onChange: handleHexChange, variant: "outlined", size: "small", slotProps: { htmlInput: {
                        maxLength: 7,
                        style: { fontFamily: '"Open Sans"' }
                    } } }), _jsx(RgbField, { label: "R", type: "number", value: values.rgb.r, onChange: handleRgbChange('r'), variant: "outlined", size: "small", slotProps: { htmlInput: {
                        min: 0,
                        max: 255,
                        style: { fontFamily: '"Open Sans"' }
                    } } }), _jsx(RgbField, { label: "G", type: "number", value: values.rgb.g, onChange: handleRgbChange('g'), variant: "outlined", size: "small", slotProps: { htmlInput: {
                        min: 0,
                        max: 255,
                        style: { fontFamily: '"Open Sans"' }
                    } } }), _jsx(RgbField, { label: "B", type: "number", value: values.rgb.b, onChange: handleRgbChange('b'), variant: "outlined", size: "small", slotProps: { htmlInput: {
                        min: 0,
                        max: 255,
                        style: { fontFamily: '"Open Sans"' }
                    } } })] }));
};
export default ColorValuesComp;
